import { computed, observable } from "mobx";

import type { Progress, Usage } from "@mainion/protocol";

export type Line = { stream: "stdout" | "stderr"; text: string };

/** One worker, as far as the events received so far tell. */
export class Worker {
    readonly controller: string;
    readonly id: string;
    @observable accessor image = "";
    @observable accessor command: string[] = [];
    @observable accessor startedAt = "";
    @observable accessor exitCode: number | undefined = undefined;
    @observable accessor progress: Progress | undefined = undefined;
    /** What its LLM calls used so far, if it reports that, like our agent does. */
    @observable accessor usage: Usage | undefined = undefined;
    @observable accessor lines: Line[] = [];

    constructor(controller: string, id: string) {
        this.controller = controller;
        this.id = id;
    }

    get key(): string {
        return workerKey(this.controller, this.id);
    }

    @computed get running(): boolean {
        return this.exitCode === undefined;
    }

    /** What the worker was asked to do: the task for our agent, or else the whole command. */
    @computed get title(): string {
        return this.command[0] === "mainion-agent" ? this.command.slice(1).join(" ") : this.command.join(" ");
    }
}

export function workerKey(controller: string, worker: string): string {
    return `${controller}/${worker}`;
}
